import mixpanel from 'mixpanel-browser';

interface useTrackingReturns {
  trackEvent: (event: string, properties: Record<string, string>) => void;
  user: {
    initialize: (userId: string) => void;
    setProperties: (
      properties: Record<string, string>,
      setMode: 'once' | 'overwrite' | 'append',
    ) => void;
    clearUser: () => void;
  };
}

export function setup() {
  mixpanel.init(import.meta.env.VITE_MIXPANEL_TOKEN, {
    debug: !import.meta.env.PROD,
  });
}

function useTracking(): useTrackingReturns {
  const trackEvent = (
    event: string = '',
    properties: Record<string, string> = {},
  ) => {
    mixpanel.track(event, properties);
  };

  const initializeUser = (userId: string) => {
    mixpanel.identify(userId);
  };

  const clearUser = () => {
    mixpanel.reset();
  };

  const setUserProperties = (
    properties: Record<string, string>,
    setMode: 'once' | 'overwrite' | 'append' = 'once',
  ) => {
    switch (setMode) {
      case 'once':
        mixpanel.people.set_once(properties);
        break;

      case 'overwrite':
        mixpanel.people.set(properties);
        break;

      case 'append':
        mixpanel.people.append(properties);
        break;
    }
  };

  return {
    trackEvent,
    user: {
      initialize: initializeUser,
      setProperties: setUserProperties,
      clearUser,
    },
  };
}

export default useTracking;
